import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { useRecoilValue } from "recoil";
import { Game } from "../../api/NertzApi";
import { useEffect, useState } from "react";
import { LineChart, mangoFusionPalette } from "@mui/x-charts";

function NertzScoreboard({ raised = true }) {
  const game = useRecoilValue(Game),
    [players, setPlayers] = useState([]);

  useEffect(() => {
    if (game && game.players) {
      setPlayers([...game.players].sort((a, b) => b.score - a.score));
    }
  }, [game, setPlayers]);

  return (
    <Card id="nertz-scoreboard" raised={raised}>
      <CardHeader title="Scoreboard" />
      <CardContent>
        <Table size="small" sx={{ width: 1 }}>
          <TableHead>
            <TableRow>
              <TableCell component="th" scope="row">
                Player
              </TableCell>
              <TableCell>Score</TableCell>
              <TableCell>Nertz</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {players.map((p) => (
              <TableRow key={p.id} hover>
                <TableCell component="th" scope="row">
                  {`${p.username} (${p.wins})`}
                </TableCell>
                <TableCell>{`${p.score}/${game.playTo}`}</TableCell>
                <TableCell>{`${p.nertz}/13`}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
      {game?.players?.length > 0 && (
        <Box sx={{ width: 1 }}>
          <LineChart
            colors={mangoFusionPalette}
            height={250}
            series={game.players.map((p) => ({
              data: p.scores || [],
              label: p.username,
            }))}
            xAxis={[
              {
                scaleType: "point",
                data: game.players[0].scores?.map((_s, i) => i + 1) || [],
              },
            ]}
          />
        </Box>
      )}
    </Card>
  );
}

export default NertzScoreboard;
